import * as React from 'react'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'
import {Button} from '@frontrow/console/src/components/button'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTrash} from '@fortawesome/free-solid-svg-icons'

// Models
import SchoolAdminsDeleteForm from '@frontrow/console/src/components/pages/school-admins-page/school-admins-delete-form'
import {type DetailedSchoolAdminT} from '@frontrow/console/src/models/school-admin'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type Props = {
  schoolAdminToDelete: DetailedSchoolAdminT
  removeSchoolAdmin: (schoolAdminId: number) => void
}

function SchoolsAdminDistrictsButtonModal(props: Props): React.ReactElement {
  const {schoolAdminToDelete, removeSchoolAdmin} = props
  const {isOpen, open, close} = useModalForm()

  const deleteSchoolAdmin = () => {
    removeSchoolAdmin(schoolAdminToDelete.id)
    close()
  }

  return (
    <React.Fragment>
      <Button style="link" title="Delete School Admin" onClick={open}>
        <FontAwesomeIcon icon={faTrash} />
      </Button>

      <Dialog
        open={isOpen}
        onClose={close}
        backdrop={<div className={dialogStyles.backdrop} />}
        className={dialogStyles.dialog}
        portal
        unmountOnHide
        hideOnEscape
        hideOnInteractOutside={false}
      >
        <div className={dialogStyles.header}>
          <DialogHeading className={dialogStyles.title}>
            Are you sure you want to delete{' '}
            {`${schoolAdminToDelete.firstName} ${schoolAdminToDelete.lastName}`}?
          </DialogHeading>
          <DialogDismiss className={dialogStyles.closeButton}>
            <span aria-hidden="true">&times;</span>
          </DialogDismiss>
        </div>
        <div className={dialogStyles.body}>
          <SchoolAdminsDeleteForm onSubmit={deleteSchoolAdmin} onCancel={close} />
        </div>
      </Dialog>
    </React.Fragment>
  )
}

export default SchoolsAdminDistrictsButtonModal
